// extracted by mini-css-extract-plugin
export default {"flags":"LanguageSwitcher_flags__eoyvM","flagWrapper":"LanguageSwitcher_flagWrapper__fu3TP","altFlag":"LanguageSwitcher_altFlag__IIu3N","altFlags":"LanguageSwitcher_altFlags__mvs7I"};